// Pairs "Starts at" / "Ends at" datetime-local inputs. When the start changes
// and the end is blank or not after the new start, default the end to one hour
// after the start. A custom end already after the new start is never touched.
//
// Example usage:
// <div data-controller="datetime-range">
//   <input type="datetime-local" data-datetime-range-target="start"
//          data-action="change->datetime-range#startChanged">
//   <input type="datetime-local" data-datetime-range-target="end">
// </div>

import { Controller } from "@hotwired/stimulus"

const DEFAULT_DURATION_MS = 60 * 60 * 1000

export default class extends Controller {
  static targets = ["start", "end"]

  startChanged() {
    if (!this.hasEndTarget) return

    const start = this.parse(this.startTarget.value)
    if (!start) return

    const end = this.parse(this.endTarget.value)
    if (end && end > start) return

    this.endTarget.value = this.format(new Date(start.getTime() + DEFAULT_DURATION_MS))
  }

  // A datetime-local value ("YYYY-MM-DDTHH:MM") parses as local time.
  parse(value) {
    if (!value) return null

    const date = new Date(value)
    return isNaN(date.getTime()) ? null : date
  }

  format(date) {
    const pad = (number) => String(number).padStart(2, "0")
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
  }
}
